import React, { useEffect, useMemo, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import '../../styles/fullcalendar.css';
import itLocale from '@fullcalendar/core/locales/it';
import { useQueryClient } from "@tanstack/react-query";
import {
  Autocomplete,
  Box,
  Button,
  TextField,
  Tooltip,
  Typography,
     Chip,
} from "@mui/material";
import dayjs from "dayjs";
import type { EventClickArg } from "@fullcalendar/core";
import type {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "material-react-table";

import { useGetPianAttDTO } from "./Services";
import EditPianAtt from "./EditPianAtt";
import AddPianAtt2 from "./AddPianAtt2";

const CalPianAtt: React.FC = () => {
  const isIframe = window.self !== window.top;
  const calendarRef = useRef<FullCalendar | null>(null);

  const [columnFilters, setColumnFilters] =
    useState<MRT_ColumnFiltersState>([]);
  const [globalFilter] = useState("");
  const [sorting] = useState<MRT_SortingState>([]);
  const [pagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 1000000,
  });


const hasCalendarRange = [
  "datainiziopian",
  "datafinepian",
].every((id) =>
  columnFilters.some((filter) => filter.id === id)
);


const keycoddip = localStorage.getItem("keycoddip") || "";
const keyrole = localStorage.getItem("keyrole") || "";
const isAdmin =  keyrole.includes('TimeReportAdmin') ||  keyrole.includes('TimeReportPianAtt');


  const [calendarTitle, setCalendarTitle] = useState("");
  // const [selectedDipendente, setSelectedDipendente] = useState<string | null>(    null  );

  // const [selectedDipendente, setSelectedDipendente] = useState<string[]>([]);

  const [selectedDipendente, setSelectedDipendente] = useState<string[]>(  !isAdmin && keycoddip ? [keycoddip] : []);

  const [selectedProgetto, setSelectedProgetto] = useState<string | null>(null);

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const [isDialogAddOpen, setIsDialogAddOpen] = useState(false);
  const [isDialogEditOpen, setIsDialogEditOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const currentViewRef = useRef<string>("dayGridMonth");

  const queryClient = useQueryClient();

  const reloadCalendar = () => {
  queryClient.invalidateQueries({ queryKey: ['fetchPianAttDTO'] });
};

  /** override date da drag/resize */
  const [eventOverrides, setEventOverrides] = useState<
    Record<string, { start: Date; end: Date }>
  >({});


  const {
    data: { results = [] } = {},
  } = useGetPianAttDTO(pagination, columnFilters, globalFilter, sorting,  { enabled: hasCalendarRange });

  /* ===================== COLORS ===================== */

  const getColorByPercomp = (percomp: number) => {
    if (percomp > 100) return "#e53935"; // Ritardo
    if (percomp === 100) return "#808080"; // Terminata
    if (percomp > 0) return "#43a047"; // In corso
    return "#1e90ff"; // Pianificata
  };

  /* ===================== OPTIONS ===================== */


  type DipendenteOption = {
  coddip: string;
  nomedip: string;
};

const dipendenteOptions = useMemo<DipendenteOption[]>(() => {
  const map = new Map<string, DipendenteOption>();

  results.forEach((r: any) => {


  if (r.coddip && r.nomedip) {
    map.set(r.coddip, {
      coddip: r.coddip,
      nomedip: r.nomedip,
    });
  }
});

  // results.forEach((r: any) => {
  //   if (r.coddip && r.nomedip) {
  //     map.set(r.coddip, {
  //       coddip: r.coddip,
  //       nomedip: r.nomedip,
  //     });
  //   }
  // });

  return Array.from(map.values()).sort((a, b) =>
    a.nomedip.localeCompare(b.nomedip, undefined, { sensitivity: 'base' })
  );
}, [results]);

  //
  // const dipendenteOptions = useMemo(
  //   () =>
  //     Array.from(
  //       new Set(results.map((r: any) => r.coddip).filter(Boolean))
  //     ),
  //   [results]
  // );

const progettoOptions = useMemo(
  () =>
    Array.from(
      new Set(results.map((r: any) => r.desprog).filter(Boolean))
    ).sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: 'base' })
    ),
  [results]
);

  /* ===================== EVENTS ===================== */

// const events = useMemo(() => {
//     return results
//       .filter((item: any) => {
//         if (selectedDipendente && item.coddip !== selectedDipendente)
//           return false;
//         if (selectedProgetto && item.desprog !== selectedProgetto)
//           return false;
//         return true;
//       })
//       .map((item: any) => {
//         const override = eventOverrides[item.id];
//
//         // const start =  override?.start ??  dayjs(item.datainiziopian).startOf("day").toDate();
//         // const end =  override?.end ??  dayjs(item.datafinepian).add(1, "day").startOf("day").toDate();
//
//         const start =
//                 override?.start ??
//                 dayjs(item.datainiziopian)
//                   .hour(Number(item.orainiz))
//                   .minute(Number(item.mininiz))
//                   .second(0)
//                   .toDate();
//
//               let end =
//                 override?.end ??
//                 dayjs(item.datafinepian)
//                   .hour(Number(item.orafine))
//                   .minute(Number(item.minfine))
//                   .second(0);
//
//               // ⛔ prevent midnight → all-day rendering
//               if (dayjs(end).hour() === 0 && dayjs(end).minute() === 0) {
//                 end = dayjs(end).subtract(1, "minute").toDate();
//               }
//
// console.log("COMPUTED TIMES", {
//   start,
//   end,
//   startISO: start.toISOString(),
//   endISO: end.toISOString(),
//   durationHours: dayjs(end).diff(dayjs(start), "hour", true),
// });
//
//         const color = getColorByPercomp(Number(item.percomp) || 0);
//
//         return {
//           id: String(item.id),
//           // title: `(${item.percomp}%) ${item.coddip}-${item.desprog?.slice( 0, 50)}-${item.desnodo?.slice(0, 50)}`,
//         title: `${item.coddip} (
//             ${String(item.orainiz).padStart(2, '0')}:${String(item.mininiz).padStart(2, '0')}
//             -
//             ${String(item.orafine).padStart(2, '0')}:${String(item.minfine).padStart(2, '0')}
//           ) ${
//             item.note?.trim()
//               ? item.note.slice(0, 50)
//               : `${item.desprog?.slice(0, 50)}-${item.desnodo?.slice(0, 50)}`
//           }`,
//           start,
//           end,
//           // allDay: true,
//           backgroundColor: color,
//           borderColor: color,
//           extendedProps: item,
//         };
//       });
//   }, [results, selectedDipendente, selectedProgetto, eventOverrides]);
const events = useMemo(() => {
  return results
    .filter((item: any) => {
      // if (selectedDipendente && item.coddip !== selectedDipendente) return false;

      if (  selectedDipendente.length > 0 &&  !selectedDipendente.includes(item.coddip))  return false;


      if (selectedProgetto && item.desprog !== selectedProgetto) return false;
      return true;
    })

   // .map((item: any) => {
   //    const isMonth = currentViewRef.current === "dayGridMonth";
   //
   //   if (isMonth) {
   //      // ✅ MONTH = ALL DAY
   //      return {
   //        id: String(item.id),
   //        title: `${item.coddip} (
   //          ${String(item.orainiz).padStart(2, '0')}:${String(item.mininiz).padStart(2, '0')}
   //          -
   //          ${String(item.orafine).padStart(2, '0')}:${String(item.minfine).padStart(2, '0')}
   //        ) ${
   //          item.note?.trim()
   //            ? item.note.slice(0, 50)
   //            : `${item.desprog?.slice(0, 50)}-${item.desnodo?.slice(0, 50)}`
   //        }`,
   //        start: dayjs(item.datainiziopian).startOf("day").toDate(),
   //        end: dayjs(item.datafinepian)
   //          .add(1, "day")          // ⬅️ end is EXCLUSIVE
   //          .startOf("day")
   //          .toDate(),
   //        allDay: true,
   //        backgroundColor: getColorByPercomp(Number(item.percomp) || 0),
   //        borderColor: getColorByPercomp(Number(item.percomp) || 0),
   //        extendedProps: item,
   //      };
   //    }
   //
   //    // ✅ WEEK = TIMED
   //    const start = dayjs(item.datainiziopian)
   //      .hour(item.orainiz)
   //      .minute(item.mininiz)
   //      .second(0)
   //      .toDate();
   //
   //    const end = dayjs(item.datafinepian)
   //      .hour(item.orafine)
   //      .minute(item.minfine)
   //      .second(0)
   //      .toDate();
   //
   //    return {
   //      id: String(item.id),
   //      title: `${item.coddip} (
   //          ${String(item.orainiz).padStart(2, '0')}:${String(item.mininiz).padStart(2, '0')}
   //          -
   //          ${String(item.orafine).padStart(2, '0')}:${String(item.minfine).padStart(2, '0')}
   //        ) ${
   //          item.note?.trim()
   //            ? item.note.slice(0, 50)
   //            : `${item.desprog?.slice(0, 50)}-${item.desnodo?.slice(0, 50)}`
   //        }`,
   //      start,
   //      end,
   //      allDay: false,
   //      backgroundColor: getColorByPercomp(Number(item.percomp) || 0),
   //      borderColor: getColorByPercomp(Number(item.percomp) || 0),
   //      extendedProps: item,
   //    };
   //  });


    .map((item: any) => {
  const isMonth = currentViewRef.current === "dayGridMonth";

  const canChangeDates =
    isAdmin ||
    item.ref === keycoddip;

  const eventTitle = `${item.coddip} (
    ${String(item.orainiz).padStart(2, '0')}:${String(item.mininiz).padStart(2, '0')}
    -
    ${String(item.orafine).padStart(2, '0')}:${String(item.minfine).padStart(2, '0')}
  ) ${
    item.note?.trim()
      ? item.note.slice(0, 50)
      : `${item.desprog?.slice(0, 50)}-${item.desnodo?.slice(0, 50)}`
  }`;

  if (isMonth) {
    return {
      id: String(item.id),
      title: eventTitle,

      start: dayjs(item.datainiziopian)
        .startOf("day")
        .toDate(),

      end: dayjs(item.datafinepian)
        .add(1, "day")
        .startOf("day")
        .toDate(),

      allDay: true,

      // solo Admin o Ref possono cambiare le date
      startEditable: canChangeDates,
      durationEditable: canChangeDates,

      backgroundColor: getColorByPercomp(Number(item.percomp) || 0),
      borderColor: getColorByPercomp(Number(item.percomp) || 0),

      extendedProps: item,
    };
  }

  const start = dayjs(item.datainiziopian)
    .hour(item.orainiz)
    .minute(item.mininiz)
    .second(0)
    .toDate();

  const end = dayjs(item.datafinepian)
    .hour(item.orafine)
    .minute(item.minfine)
    .second(0)
    .toDate();

  return {
    id: String(item.id),
    title: eventTitle,
    start,
    end,

    allDay: false,

    // solo Admin o Ref possono cambiare date/orari
    startEditable: canChangeDates,
    durationEditable: canChangeDates,

    backgroundColor: getColorByPercomp(Number(item.percomp) || 0),
    borderColor: getColorByPercomp(Number(item.percomp) || 0),

    extendedProps: item,
  };
});







}, [results, selectedDipendente, selectedProgetto]);

  /* ===================== HANDLERS ===================== */

  const handleEventClick = (arg: EventClickArg) => {
    setSelectedId(arg.event.id);
    setIsDialogEditOpen(true);
  };

  // const handleEventChange = (event: any) => {
  //   const start = dayjs(event.start!).startOf("day");
  //   const end = event.end
  //     ? dayjs(event.end).startOf("day")   // ⬅️ ESCLUSIVO
  //     : start.add(1, "day").startOf("day");
  //
  //   setEventOverrides((prev) => ({
  //     ...prev,
  //     [event.id]: {
  //       start: start.toDate(),
  //       end: end.toDate(),
  //     },
  //   }));
  //
  //   setSelectedId(event.id);
  //   setIsDialogEditOpen(true);
  // };

  const handleEventChange = (event: any) => {
  const isMonth = currentViewRef.current === "dayGridMonth";

  if (isMonth) {
    // 👉 MONTH: ONLY change date, keep hours untouched
    const start = dayjs(event.start).startOf("day");

    const end = event.end
      ? dayjs(event.end).subtract(1, "day").startOf("day") // fix exclusive
      : start;

    setEventOverrides((prev) => ({
      ...prev,
      [event.id]: {
        start: start.toDate(),
        end: end.toDate(),
      },
    }));
  } else {
    // 👉 WEEK: change full datetime
    const start = event.start;
    const end = event.end ?? new Date(start.getTime() + 60 * 60 * 1000);

    setEventOverrides((prev) => ({
      ...prev,
      [event.id]: {
        start: new Date(
          start.getFullYear(),
          start.getMonth(),
          start.getDate(),
          start.getHours(),
          start.getMinutes()
        ),
        end: new Date(
          end.getFullYear(),
          end.getMonth(),
          end.getDate(),
          end.getHours(),
          end.getMinutes()
        ),
      },
    }));
  }

  setSelectedId(event.id);
  setIsDialogEditOpen(true);
};


//  const handleDateClick = (arg: any) => {
//   const isWeek = currentViewRef.current === "timeGridWeek";
//
//   if (isWeek) {
//     // 👉 week: giorno + ora cliccata
//     setSelectedDate(arg.date);
//   } else {
//     // 👉 month: comportati come "Nuova Att."
//     setSelectedDate(null);
//   }
//
//   setIsDialogAddOpen(true);
// };

 const handleDateClick = (arg: any) => {
  setSelectedDate(arg.date);   // ✅ month AND week
  setIsDialogAddOpen(true);
};

  const lastRangeRef = useRef<string | null>(null);

const handleDatesSet = (info: any) => {
  currentViewRef.current = info.view.type;

  setCalendarTitle(info.view.title);

  setColumnFilters((prev) => {
    const calendarStart = dayjs(info.view.currentStart)
      .format("YYYY-MM-DD");

    // currentEnd è esclusiva
    const calendarEnd = dayjs(info.view.currentEnd)
      .subtract(1, "day")
      .format("YYYY-MM-DD");

    const next: MRT_ColumnFiltersState = [
      {
        // attività iniziata PRIMA della fine del periodo
        id: "datainiziopian",
        value: [null, calendarEnd],
      },
      {
        // attività terminata DOPO l'inizio del periodo
        id: "datafinepian",
        value: [calendarStart, null],
      },
    ];

    if (JSON.stringify(prev) === JSON.stringify(next)) {
      return prev;
    }

    return next;
  });
};
  /* ===================== UI ===================== */

  return (
    <Box sx={{
            mt: "60px",
              height: isIframe ? "100vh" : "calc(100vh - 64px)", // app bar height
              boxSizing: "border-box",
              backgroundColor: isIframe ? "#fff" : undefined,
              display: "flex",
              flexDirection: "column",
              overflowY: isIframe ? "auto" : undefined,
              overflowX: "hidden",
          }}>
      {/* HEADER */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          mb: 1,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
         <Typography
  variant="h6"
  fontWeight={600}
  sx={{ textTransform: 'uppercase' }}
>
  {calendarTitle}
</Typography>


  </Box>

        <Button
  size="small"
  variant="contained"
  onClick={() => {
    setSelectedDate(null);   // 👈 fondamentale
    setIsDialogAddOpen(true);
  }}
>
  Nuova Att.
</Button>

        {/* FILTERS */}
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          {/*<Autocomplete*/}
          {/*      size="small"*/}
          {/*      options={dipendenteOptions}*/}
          {/*      getOptionLabel={(option) => option.nomedip}*/}
          {/*      isOptionEqualToValue={(opt, val) => opt.coddip === val.coddip}*/}
          {/*      value={*/}
          {/*        dipendenteOptions.find(o => o.coddip === selectedDipendente) ?? null*/}
          {/*      }*/}
          {/*      onChange={(_, option) =>*/}
          {/*        setSelectedDipendente(option ? option.coddip : null)*/}
          {/*      }*/}
          {/*      sx={{ minWidth: 250 }}*/}
          {/*      renderInput={(params) => (*/}
          {/*        <TextField {...params} label="Risorsa" />*/}
          {/*      )}*/}
          {/*    />*/}
<Autocomplete
  multiple
  size="small"
  options={dipendenteOptions}
  getOptionLabel={(option) => option.nomedip}
  isOptionEqualToValue={(opt, val) => opt.coddip === val.coddip}

  renderOption={(props, option, { selected }) => (
    <li
      {...props}
      style={{
        ...props.style,
        // fontWeight: selected ? 700 : 400,
        backgroundColor: selected ? "#d0d0d0" : undefined,
        // borderLeft: selected
        //   ? "4px solid #1976d2"
        //   : "4px solid transparent",
      }}
    >
      {option.nomedip}
    </li>
  )}

  value={dipendenteOptions.filter((o) =>
    selectedDipendente.includes(o.coddip)
  )}

  onChange={(_, options) =>
    setSelectedDipendente(options.map((o) => o.coddip))
  }

  renderTags={(value, getTagProps) => {
    const visible = value.slice(0, 1);
    const hiddenCount = value.length - visible.length;

    return (
      <>
        {visible.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={option.coddip}
            label={option.nomedip}
            size="small"
          />
        ))}

        {hiddenCount > 0 && (
          <Chip
            label={`+${hiddenCount}`}
            size="small"
          />
        )}
      </>
    );
  }}

  sx={{ minWidth: 200 }}

  renderInput={(params) => (
    <TextField {...params} label="Risorse" />
  )}
/>


          <Autocomplete
            size="small"
            options={progettoOptions}
            value={selectedProgetto}
            onChange={(_, v) => setSelectedProgetto(v)}
            sx={{ minWidth: 300 }}
            renderInput={(params) => (
              <TextField {...params} label="Progetto" />
            )}
          />
        </Box>

        {/* NAV */}
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            size="small"
            variant="contained"
            onClick={() => calendarRef.current?.getApi().prev()}
          >
            &lt;&lt;
          </Button>
            <Button
            size="small"
            variant="contained"
            onClick={() => calendarRef.current?.getApi().next()}
          >
                    &gt;&gt;
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() => calendarRef.current?.getApi().today()}
          >
            OGGI
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={() =>
              calendarRef.current?.getApi().changeView("dayGridMonth")
            }
          >
           MESE
          </Button>

           <Button
            size="small"
            variant="contained"
            onClick={() =>
              calendarRef.current?.getApi().changeView("timeGridWeek")
            }
          >
            Sett
          </Button>

        </Box>

        <Box>
         <Typography variant="caption" sx={{ color: "#9E9E9E", ml: 1 }}>
            <span style={{ color: "#1e90ff" }}>■</span> Pianificata&nbsp;
            <span style={{ color: "#43a047" }}>■</span> In corso&nbsp;
            <span style={{ color: "#808080" }}>■</span> Terminata&nbsp;
            <span style={{ color: "#e53935" }}>■</span> Ritardo&nbsp;
          </Typography>
        </Box>

      </Box>

      {/* CALENDAR */}
      <FullCalendar
        ref={calendarRef}
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        locales={[itLocale]}
        locale="it"
        initialView="dayGridMonth"
        headerToolbar={false}
        events={events}

          /* 🔒 PREVENT DAY CELL GROWTH */
           height="auto"
          // height={720}
          fixedWeekCount={true}
          expandRows={true}
          dayMaxEvents={7}
          dayMaxEventRows={7}

          /* tighter events */
          // // eventDisplay="block"
          // eventMinHeight={14}
          // eventShortHeight={14}

          views={{
                dayGridMonth: {
                  eventMinHeight: 14,
                  eventShortHeight: 14,
                },
                timeGridWeek: {
                  eventMinHeight: undefined,
                  eventShortHeight: undefined,
                  slotMinTime: "08:00:00",
                  slotMaxTime: "19:00:00",
                },
              }}




        editable
        selectable
        eventClick={handleEventClick}
        eventDrop={(i) => handleEventChange(i.event)}
        eventResize={(i) => handleEventChange(i.event)}
        dateClick={handleDateClick}
        datesSet={handleDatesSet}
        eventContent={(arg) => (
          <Tooltip
            title={
                <>
                    <div>
                        <b>Dipendente:</b>{" "}
                        {arg.event.extendedProps.coddip}
                    </div>
                    <div>
                        <b>Progetto:</b>{" "}
                        {arg.event.extendedProps.desprog}
                    </div>
                    <div>
                        <b>Nodo:</b>{" "}
                        {arg.event.extendedProps.desnodo}
                    </div>
                    <div>
                        <b>Note:</b>{" "}
                        {arg.event.extendedProps.note}
                    </div>
                </>
            }
            arrow
          >
              <div className="fc-event-text">
                  {arg.event.title}
            </div>
          </Tooltip>
        )}
      />

      {/* DIALOGS */}
      {isDialogAddOpen && (
        <AddPianAtt2
          open
          defaultDate={selectedDate}
          onClose={() => setIsDialogAddOpen(false)}
        />
      )}

      {isDialogEditOpen && selectedId && (
        <EditPianAtt
          open
          propidattivita={selectedId}
          datainiziopian={eventOverrides[selectedId]?.start}
          // datafinepian={
          //   eventOverrides[selectedId]?.end
          //     ? dayjs(eventOverrides[selectedId].end)
          //         .subtract(1, "day")
          //         .toDate()
          //     : undefined
          // }
          datafinepian={eventOverrides[selectedId]?.end}
          // onClose={() => setIsDialogEditOpen(false)}

          onClose={() => {
                      setIsDialogEditOpen(false);
                      setSelectedId(null);
                      setEventOverrides({});   // 🔑 remove temporary drag
                      reloadCalendar();        // 🔑 reload from backend
                    }}

        />
      )}
    </Box>
  );
};

export default CalPianAtt;
